import {athubAxios} from "../../../util/athub-axios";

const qualification = {
    page: page,
    add: add,
    update: update,
    remove: remove,
    checkName: checkQualificationNameAvailable,
    findById: findById,
    valid: valid,
    invalid: invalid,
};

export default qualification;

import {ORGANIZATION_SERVER} from '@/api/server'

/**
 * 条件查询专业认证列表分页信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function page(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/qualification/page`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 检查资质名称是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkQualificationNameAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/qualification/check/name`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 添加专业认证信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function add(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/qualification`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 修改专业认证信息
 * @param id 专业认证ID
 * @param params
 * @returns {Promise<unknown>}
 */
export function update(id, params) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/qualification/${id}`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 删除专业认证信息
 * @param id 专业认证ID
 * @returns {Promise<unknown>}
 */
export function remove(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.delete(`${ORGANIZATION_SERVER}/qualification/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 根据专业认证ID查询专业认证详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function findById(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/qualification/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 启用
 * @param params
 * @returns {Promise<unknown>}
 */
export function valid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/qualification/${id}/valid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 停用
 * @param params
 * @returns {Promise<unknown>}
 */
export function invalid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/qualification/${id}/invalid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}